import { Directive } from '@angular/core';

/**
 * @ignore
 */
@Directive({ selector: 'np-panel-header' })
export class NpPanelHeaderDirective {
    constructor() { }
}